module.exports = __webpack_public_path__ + "media/photo/telecom_bgs-24b2e909.jpg";